module.exports = __webpack_public_path__ + "img/10551376_L.832845cd.png";